export default function (state, val) {
    state.form.AgreementCodes.push(val.code);
    state.system.code = val.code;
}